// extracted by mini-css-extract-plugin
export default {"mainYellowColor":"#f7df1c","borderYellowColor":"#e5d023"};